module.exports = __webpack_public_path__ + "img/icon_school_bag3.b049680.png";